<template>
  <div class="box">
    <div class="title">Loan Contract</div>
    <div class="content">
      The borrower applies to Kinvest for the loan, and both parties have signed
      this loan contract according to their true intentions and after
      negotiation. This loan contract is a specific loan contract signed by both
      parties, with the objective of binding the parties to the terms herein.
    </div>
    <div class="list">Borrower name: {{ name | GetStr4 }}</div>
    <div class="list">Borrower ID number: {{ idNumber | GetStr4 }}</div>
    <div class="list">Loan amount: {{ applyAmount }} shillings</div>
    <div class="list">
      Loan period: {{ period }} {{ IsTest ? "months" : "weeks" }} (period)
    </div>
    <div class="list">Deposit amount: Shilling {{ totalBalance }}</div>
    <div class="list">
      Start and end time: {{ createDate }} -{{ lastPayDate }}
    </div>
    <div class="list">Receiving account: {{ receiveAccount | GetStr4 }}</div>
    <div class="list">Repayment method: equal amount in each installment</div>
    <div class="list">First repayment date: {{ firstPayDate }}</div>
    <div class="list">
      Repayment date:
      {{ IsTest ? "monthly repayment" : "Repayment every 7 days" }}
    </div>
    <div class="list">Loan provider: KINVEST</div>
    <div class="list">Contract signing date: {{ createDate }}</div>
    <div class="content">
      Note: The specific loan information is subject to the actual issuance, and
      the specific repayment information is subject to the repayment plan
      displayed by the borrower online.
    </div>
    <common :IsTest="IsTest"></common>
  </div>
</template>
<script>
import axios from "@/http/axios";
import common from "@/compent/common";
export default {
  data() {
    return {
      applyAmount: "",
      createDate: "",
      firstPayDate: "",
      groupId: "",
      lastPayDate: "",
      period: "",
      receiveAccount: "",
      totalBalance: "",
      idNumber: "",
      name: "",
      IsTest: true,
    };
  },
  components: {
    common,
  },
  created() {
    let o = this.$route.query;
    let NowDate =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate();
    sessionStorage.setItem("token", o.token);
    this.applyAmount = o.applyAmount;
    this.createDate = o.createDate ? o.createDate : NowDate;
    this.firstPayDate = o.firstPayDate;
    this.groupId = o.groupId;
    this.lastPayDate = o.lastPayDate;
    this.period = o.period;
    this.receiveAccount = o.receiveAccount;
    axios.post("/api/appgateway/loan/totalAssets", {}).then((res) => {
      if (res.code == "00000") {
        this.totalBalance = res.data.totalBalance;
      }
    });
    axios.post("/api/appgateway/loan/getUserkyc", {}).then((res) => {
      if (res.code == "00000") {
        this.name =
          res.data.firstName +
          " " +
          res.data.middleName +
          " " +
          res.data.lastName;
        this.idNumber = res.data.idNumber;
      }
    });
    axios.post("/api/appgateway/user/getUserInfo", {}).then((res) => {
      if (res.code == "00000") {
        this.IsTest = res.data.userType == "99";
      }
    });
  },
  methods: {},
  filters: {
    GetStr4(str) {
      if (str) {
        let t = "",
          len = str.length;
        if (len < 4 || len == 4) {
          t = str;
        } else {
          for (let i = 0; i < len; i++) {
            if (len - i > 4) {
              t += "*";
            } else {
              t += str[i];
            }
          }
        }
        return t;
      } else {
        return str;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import url("../../assets/css/index.css");
.box {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  background-color: #f9f9f9;
  padding: 20px 4%;
  box-sizing: border-box;
  .title {
    font-family: "rb";
    font-weight: bold;
    color: #333333;
    line-height: 28px;
    z-index: 2;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .content {
    font-family: "rr";
    color: #333333;
    line-height: 24px;
    z-index: 2;
    font-size: 14px;
    margin: 20px 0;
  }
  .list {
    font-family: "rr";
    color: #333333;
    line-height: 24px;
    z-index: 2;
    font-size: 14px;
    margin: 10px 0;
  }
}
</style>
